import type { RatingSurveyResponse } from "@repo/app-types/entities/answer";
import type React from "react";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { RadioButtonsRow } from "../Buttons/radioButtonsRow.js";

const focusStyle = "focus:outline focus:outline-1 focus:outline-indigo-600";

interface SurveyQuestionTableProps {
  columnNames: string[];
  rowNames: string[];
  rowRefs?: React.RefObject<HTMLTableCellElement | null>[];
  onChange?: (rowName: string, index: number) => void;
  isReadOnly?: boolean;
  currentRatings: RatingSurveyResponse[];
}

export const SurveyQuestionTable: FC<SurveyQuestionTableProps> = ({
  columnNames,
  rowNames,
  rowRefs,
  onChange,
  isReadOnly,
  currentRatings,
}) => {
  return (
    <table className="w-full divide-y divide-gray-300">
      <thead>
        <tr>
          <th />
          {columnNames.map((name) => (
            <th
              className={twMerge(
                "w-[12%] pb-2 text-xs text-foreground",
                isReadOnly ? "font-medium" : "font-semibold",
              )}
              key={`col-${name}`}
            >
              {name}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {rowNames.map((rowName, rowIndex) => (
          <tr key={`row-${rowName}`}>
            <td
              className={twMerge(
                "text-sm text-foreground",
                isReadOnly ? "py-1" : "py-2 font-medium",
              )}
            >
              {rowName}
            </td>
            <td
              className={isReadOnly ? "" : focusStyle}
              colSpan={columnNames.length}
              ref={rowRefs ? rowRefs[rowIndex] : undefined}
              tabIndex={isReadOnly ? undefined : rowIndex}
            >
              <RadioButtonsRow
                isReadOnly={isReadOnly}
                onChange={(index) => {
                  if (onChange) onChange(rowName, index);
                }}
                optionsCount={columnNames.length}
                rowIndex={rowIndex}
                selectionIndex={
                  currentRatings.find((rating) => rating.name === rowName)
                    ?.rating
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
